import {useState} from "react";
import {useDispatch} from "react-redux";
import {toast} from "react-toastify";
import Modal from 'react-bootstrap/Modal';

import {Loading} from "../../utils/helpers/constants";
import TokenHelper from "../../utils/helpers/tokenHelper";
import {getProfile} from "../../store/actions/profile.action";
import ProfileService from "../../utils/services/profile.service";


const OrganisationSwitcherModal = ({onchange, organisations, setOrganisation, activeOrganisation}) => {
  const dispatch = useDispatch();
  const [show, setShow] = useState(true);
  const [organisationsList, setOrganisationsList] = useState(organisations);


  const handleClose = () => {
    setShow(false);
    onchange();
  }

  const handleOrganisationSearch = (event) => {
    const searchData = event.target.value;
    if (searchData.length <= 1) setOrganisationsList(organisations);
    else {
      const filteredOrganisations = organisations.filter(data => JSON.stringify(data).toLowerCase().indexOf(searchData.toLowerCase()) !== -1);
      setOrganisationsList(filteredOrganisations);
    }
  }

  const toggleFavouriteOrg = async organisation => {
    const {data: responseData} = await ProfileService.favouriteOrganisation(organisation.reference);
    if (responseData.status !== Loading.SUCCESS) toast.error(responseData.message);
    else dispatch(getProfile());
  }

  const switchAccount = async organisation => {
    if (organisation.reference === TokenHelper.getSelectedOrg()) handleClose();
    else {
      setOrganisation(organisation);
      handleClose();
    }
  }

  return (
    <>
      <Modal show={show} backdrop="static" size="lg" keyboard={false} scrollable={true} centered={true}>
        <div className="modal-header">
          <h4 className="modal-title">Select an organisation profile</h4>
          <button aria-label="Close" onClick={handleClose} className="btn-close" data-bs-dismiss="modal"/>
        </div>
        <Modal.Body>
          <div className="row">
            <div className="col-lg-8 offset-lg-2 my-3">
              <div className="input-group">
                <input className="form-control" placeholder="Search for organisation ..." type="text"
                       onChange={e => handleOrganisationSearch(e)}/>
                <span className="input-group-btn">
                  <button className="btn ripple btn-primary" type="button" onChange={e => handleOrganisationSearch(e)}>
													<span className="input-group-btn"><i className="fa fa-search"></i></span>
                  </button>
                </span>
              </div>
            </div>
          </div>
          <div className="row my-4">
            <div className="col-12">
              <div className="table-responsive border">
                <table className="table table-striped text-nowrap text-md-nowrap mg-b-0">
                  <thead>
                  <tr>
                    <th></th>
                    <th className="w-75 ms-5">Name</th>
                    <th>Reference</th>
                  </tr>
                  </thead>
                  <tbody>
                  {organisationsList.map((organisation, index) =>
                    <tr key={index}>
                      <td>
                        <i onClick={() => toggleFavouriteOrg(organisation)}
                           className={`zmdi ${organisation["is_favourite"] ? "zmdi-star text-warning" : "zmdi-star-border"} 
                           zmdi-hc-lg me-2 pointer-event`}/>
                        {(activeOrganisation().reference === organisation.reference) &&
                          <i className="zmdi zmdi-check zmdi-hc-lg text-success me-2"/>}
                      </td>
                      <td onClick={() => switchAccount(organisation)} className="w-75 pointer-event">
                        {organisation?.name}
                      </td>
                      <td>{organisation?.reference}</td>
                    </tr>
                  )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
};

export default OrganisationSwitcherModal;
